import { url, header } from "../../apis/Index";
import { toast } from "react-toastify";
import axios from "axios";

export const getProfileInfo = () => {
  return (dispatch) => {
    axios
      .get(`${url}/v1/users`, {
        headers: header,
      })
      .then((profiles) => {
        dispatch({
          type: "GET_PROFILES",
          profiles,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const getProfileInfoById = (id) => {
  return (dispatch) => {
    axios
      .get(`${url}/v1/users/${id}`, {
        headers: header,
      })
      .then((profile) => {
        dispatch({
          type: "GET_PROFILE",
          profile,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const updateProfileInfo = (updatedProfile, id) => {
  return (dispatch) => {
    console.log(updatedProfile);
    axios
      .put(`${url}/v1/users/api/users/${id}`, updatedProfile, {
        headers: header,
      })
      .then((profile) => {
        dispatch({
          type: "UPDATE_PROFILE",
          profile,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to update profile", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      });
  };
};

export const deleteProfileInfo = (id) => {
  return (dispatch) => {
    axios
      .delete(`${url}/v1/users/api/users${id}`, {
        headers: header,
      })
      .then(() => {
        dispatch({
          type: "DELETE_PROFILE",
          id,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to delete profile", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      });
  };
};
